import type { Block, ColorBlock } from '@basehub/data/replicache/index'
import * as PropertiesPanel from '../../properties-panel'

export const ColorBlockPropertiesPanel = ({
  block,
  parent,
  path,
}: {
  block: ColorBlock
  parent: Block
  path: string
}) => {
  return (
    <PropertiesPanel.PropertiesContainer>
      <PropertiesPanel.CommonSearchConfigGroup
        block={block}
        parent={parent}
        path={path}
      />
    </PropertiesPanel.PropertiesContainer>
  )
}
